/**
 * Legal Translation Helpers
 *
 * Small guards for legal-page translation values during static prerender.
 *
 * Primary responsibilities:
 * - Convert translated list values into string arrays
 * - Fall back to stable legal copy when translations are not loaded yet
 *
 * Dependencies:
 * - None
 */

export function readTranslatedText(value: unknown, fallback: string): string {
  if (typeof value !== 'string') {
    return fallback
  }

  const text = value.trim()

  if (!text || text.startsWith('privacy.') || text.startsWith('terms.')) {
    return fallback
  }

  return text
}

export function readTranslatedItems(value: unknown, fallback: readonly string[]): string[] {
  const values = Array.isArray(value)
    ? value
    : value && typeof value === 'object'
      ? Object.values(value as Record<string, unknown>)
      : []

  const items = values.filter(
    (item): item is string => typeof item === 'string' && item.trim().length > 0
  )

  return items.length > 0 ? items : [...fallback]
}
